import { InternalRole } from './endpoints/MeEndpoint.types';

/** Client mirror of `roles.server.ts` — keep both rank tables in sync. */
export function roleToNumber(role: InternalRole | 'Anonymous' | null | undefined): number {
  switch (role) {
    case 'InternalOwner': {
      return 30;
    }
    case 'InternalAdminPlus': {
      return 20;
    }
    case 'InternalAdmin': {
      return 10;
    }
    case 'InternalEmployeePlus': {
      return 5;
    }
    case 'InternalEmployeePlanning': {
      return 1;
    }
    case 'Anonymous': {
      return 0;
    }
    default: {
      return 0;
    }
  }
}
